import { defineMessages } from 'react-intl';

export default defineMessages({
    analytics: {
        id: 'e1p.app.html.index.Analytics',
        defaultMessage: 'Analytics'
    },

    growthAnalytics: {
        id: 'e1p.portal.infocenter.tab.Growth',
        defaultMessage: 'Growth',
    },

    lossratiosAnalytics: {
        id: 'e1p.portal.infocenter.tab.Loss Ratios',
        defaultMessage: 'Loss Ratios',

    }
});
